import { Link } from "react-router-dom";
import { m as motion } from "framer-motion";
import { ArrowRight, Truck } from "lucide-react";
import { NAV } from "@/data/nav";
import { SITE } from "@/data/site";
import { LakeMap } from "../LakeMap";

const get = (k) => NAV.find((n) => n.mega === k);

const ViewAll = ({ to, label, testId }) => (
  <Link to={to} className="group inline-flex items-center gap-2 text-sm font-bold" data-testid={testId}>
    {label} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
  </Link>
);

const Contractors = () => {
  const m = get("contractors");
  return (
    <div className="grid gap-8 lg:grid-cols-[1fr_1fr_1.1fr]">
      <div>
        <p className="eyebrow text-[#5a4a33]">Programs</p>
        <ul className="mt-4 space-y-1">
          {m.items.map((it) => (
            <li key={it.href}>
              <Link to={it.href} className="block rounded-lg px-3 py-2.5 text-lg font-bold transition-colors hover:bg-[#f6f4ef]" data-testid={`mega-link-${it.href.split("/").pop()}`}>{it.label}</Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <p className="eyebrow text-[#5a4a33]">Who we supply</p>
        <ul className="mt-4 space-y-1">
          {m.audiences.map((it) => (
            <li key={it.href}>
              <Link to={it.href} className="block rounded-lg px-3 py-2 font-semibold text-[#333] transition-colors hover:bg-[#f6f4ef]" data-testid={`mega-link-${it.href.split("/").pop()}`}>{it.label}</Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="rounded-xl bg-[#111] p-7 text-white">
        <Truck className="h-8 w-8 text-[#F2C200]" />
        <p className="mt-4 text-2xl font-extrabold leading-tight">Wholesale flooring, delivered to your jobsite.</p>
        <p className="mt-2 text-sm text-zinc-300">Contractor pricing, volume discounts and repeat-order support.</p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link to="/contractor-pricing" className="btn btn-yellow" data-testid="mega-contractor-pricing-btn">Request Pricing</Link>
          <Link to="/contractors" className="btn btn-light" data-testid="mega-contractor-program-btn">Program</Link>
        </div>
      </div>
    </div>
  );
};

const Areas = () => {
  const m = get("areas");
  return (
    <div className="grid gap-8 lg:grid-cols-[1.3fr_1fr]">
      <ul className="grid gap-2 sm:grid-cols-2">
        {m.items.map((it) => (
          <li key={it.href} className="rounded-xl border border-[#eee] p-4 transition-colors hover:border-[#111]">
            <Link to={it.href} className="block text-lg font-extrabold" data-testid={`mega-area-${it.href.split("/").pop()}`}>{it.label}</Link>
            <div className="mt-1 flex gap-4 text-sm">
              <Link to={it.href} className="text-[#555] hover:text-[#111]">Homeowners</Link>
              <Link to={it.contractor} className="text-[#555] hover:text-[#111]">Contractors</Link>
            </div>
          </li>
        ))}
        <li className="flex items-center p-4"><ViewAll to="/service-areas" label="All service areas" testId="mega-areas-all" /></li>
      </ul>
      <div className="rounded-xl bg-[#f6f4ef] p-4">
        <LakeMap compact />
        <p className="px-2 pb-1 text-sm text-[#555]">Based in {SITE.city} on Lake Norman.</p>
      </div>
    </div>
  );
};

const PANELS = { contractors: Contractors, areas: Areas };

export const MegaPanel = ({ which }) => {
  const P = PANELS[which];
  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -6 }}
      transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
      className="absolute inset-x-0 top-full hidden border-b border-[#ebe7de] bg-white shadow-[0_40px_60px_-30px_rgba(0,0,0,0.35)] lg:block"
      data-testid={`mega-panel-${which}`}
    >
      <div className="wrap py-9">
        <P />
      </div>
    </motion.div>
  );
};
